import { generateUrlByEnv } from './EnvUtils';
import { JsBridge } from './JsBridge';

export function queryURLParams(location: string) {
  let obj: Record<string, any> = {};
  location.replace(
    /([^?=&#]+)=([^?=&#]+)/g,
    (_, key, value) => (obj[key] = decodeURIComponent(value))
  );
  return obj;
}

export const dealPhone = (text: string) => {
  if (!text) return text;
  if (text.length < 11) return text;

  return text.slice(-11).replace(/^(.{3})(.{4})(.*)$/, '$1****$3');
};

export const logInJsx = (message?: any, ...optionalParams: any[]): string => {
  console.log(message, optionalParams);
  return '';
};

export function getPathFromUrl(url: string) {
  if (!url) return '';
  const match = url.match(/:\/\/(.[^/]+)(.*)/);
  return match ? match[2] : '';
}

export function openWebView({
  path,
  title,
  showShare = false,
  hasNaviBar = true
}: {
  path: string;
  title: string;
  showShare?: boolean;
  hasNaviBar?: boolean;
}) {
  const data = JSON.stringify({
    url: generateUrlByEnv(path),
    title,
    showShare,
    hasNaviBar,
  });
  JsBridge.openWebPage(data);
}

export function generateUUIDv4(): string {
  // RFC4122 version 4 UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}
